
export default {
  props: ['collone1Diplomas','collone2Diplomas','collone3Diplomas','nomCollone1','nomCollone2','nomCollone3']
}
